import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/components/home/HomePage";
import { homeHead } from "@/components/home/home-head";
import { loadHome } from "@/components/home/home-loader";

// Русский лендинг по ЗАКРЕПЛЁННОМУ адресу.
//
// Файл — ru.index.tsx, а не ru.tsx: ru.tsx стал бы рамкой для ru.tutors.* и
// без <Outlet/> рисовал бы главную вместо них (та же ловушка, что у az/en, PR #350).
//
// До этого русский был единственным языком без своего пути: /az и /en
// закреплены адресом, а русский — только кукой yt-lang, которую ставит
// переключатель. Кука работает (проверено на бою: с азербайджанским
// браузером и yt-lang=ru корень отдаёт русский), но закрепление кукой
// слабее закрепления адресом сразу в двух местах.
//
// Первое: ссылку на русский лендинг некому дать. Она выглядит как «/», и
// у получателя с азербайджанским браузером открывается по-азербайджански —
// то есть скопированная ссылка не переносит язык, потому что язык живёт не
// в ней, а в куке отправителя.
//
// Второе: браузер, режущий куки, отбирает у русского читателя русский
// целиком, а у азербайджанского и английского — ничего.
//
// Отдаётся тот же файл, что и на «/», вместе с его canonical на «/»: для
// поиска русская страница остаётся одна, в корне, а /ru — вход, который
// можно дать человеку.
//
// Автоопределение на «/» не тронуто и трогать его не надо: оно задумано и
// работает. См. autoLangRedirect в src/server.ts.
//
// ЦЕНА ПРЕДЫДУЩЕГО РЕШЕНИЯ, чтобы не повторить. До этой страницы /ru отдавал
// 301 на «/». Постоянный редирект браузер кеширует навсегда: у всех, кто
// открыл /ru хотя бы раз до починки, он и дальше уводит на «/», не спрашивая
// сервер. Проверять такую починку надо в приватном окне, иначе замер покажет
// старое поведение и чинить будешь починенное.
//
// Правило отсюда: путь, который может когда-нибудь понадобиться, закрывают
// временным 302, а не постоянным 301. Разница в цене — ноль, разница в
// обратимости — вся.
//
// С 05.10.2026 главная — React (src/components/home). Кука yt-lang=ru по-прежнему
// ставится ответом сервера на /ru — теперь в src/server.ts (pathLangCookie),
// потому что React-маршрут заголовков ответа не задаёт.
export const Route = createFileRoute("/ru/")({
  // Число стран для пина «за рубежом» и ссылки «Populyar» (29.10.2026). Сбой любой части — без неё.
  loader: () => loadHome("ru"),
  head: () => homeHead("ru"),
  component: function Page() {
    const data = Route.useLoaderData();
    return <HomePage lang="ru" countries={data.countries} popular={data.popular} />;
  },
});
